import { render } from "./SliderAliados.vue?vue&type=template&id=3efbccc4&scoped=true&ts=true"
import script from "./SliderAliados.ts?vue&type=script&lang=ts&external"
export * from "./SliderAliados.ts?vue&type=script&lang=ts&external"

import "./SliderAliados.vue?vue&type=style&index=0&id=3efbccc4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3efbccc4"]])

export default __exports__